export const CUSTOMER_ID = 'customer_id';
export const WISHLIST_ITEMS_COUNT_LIMIT = 8;
